import { useEffect } from "react";

function Notification({ message, type = "success", onClose, duration = 3000 }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  const alertClass = {
    success: "alert-success",
    error: "alert-danger",
    info: "alert-info",
    warning: "alert-warning",
  }[type] || "alert-info";

  return (
    <div
      className={`alert ${alertClass} alert-dismissible fade show position-fixed`}
      style={{ top: 20, right: 20, zIndex: 10000, minWidth: 300 }}
      role="alert"
    >
      {message}
      <button type="button" className="btn-close" onClick={onClose} />
    </div>
  );
}

export default Notification;
